// 2_components/phone_input.js
// Checkout / account phone field: keep Shoptet's prefix dropdown, but pin
// CZ / SK / PL to the top (shop locale first, then the other two markets).

import { getShopLang } from "../0_global/shop_map";

const PREFERRED_BY_LANG = {
	cs: ["CZ", "SK", "PL"],
	sk: ["SK", "CZ", "PL"],
};

export function init() {
	reorderPhonePrefixes();
	document.addEventListener("ShoptetDOMContentLoaded", reorderPhonePrefixes);
}

function getPreferredCodes() {
	return PREFERRED_BY_LANG[getShopLang()] || PREFERRED_BY_LANG.cs;
}

function parseOptionCountryCode(option) {
	try {
		return JSON.parse(option.value)?.countryCode || "";
	} catch (error) {
		return "";
	}
}

function getFlagCountryCode(flag) {
	const fromData = flag.getAttribute("data-rel");
	if (fromData) return fromData;
	const fromClass = flag.className.match(/country-flag-([A-Z]{2})\b/);
	return fromClass ? fromClass[1] : "";
}

function reorderFlagList(inner, preferredCodes) {
	const flags = Array.from(inner.querySelectorAll(".country-flag"));
	if (flags.length < 2) return;

	const byCode = new Map(flags.map((flag) => [getFlagCountryCode(flag), flag]));
	const preferredFlags = preferredCodes.map((code) => byCode.get(code)).filter(Boolean);
	if (!preferredFlags.length) return;

	const fragment = document.createDocumentFragment();
	preferredFlags.forEach((flag) => {
		flag.classList.add("country-flag-preferred");
		fragment.appendChild(flag);
	});
	inner.insertBefore(fragment, inner.firstChild);
}

function markLastPreferred(group) {
	group.querySelectorAll(".country-flag-preferred-last").forEach((flag) => {
		flag.classList.remove("country-flag-preferred-last");
	});
	const preferred = group.querySelectorAll(".country-flag-preferred:not(.selected)");
	if (preferred.length) {
		preferred[preferred.length - 1].classList.add("country-flag-preferred-last");
	}
}

function reorderPhoneCodeSelect(select, preferredCodes) {
	if (!select) return;

	const options = Array.from(select.options);
	if (options.length < 2) return;

	const preferredOptions = preferredCodes.map(() => null);
	const rest = [];

	options.forEach((option) => {
		const countryCode = parseOptionCountryCode(option);
		const preferredIndex = preferredCodes.indexOf(countryCode);
		if (preferredIndex === -1) {
			rest.push(option);
			return;
		}
		preferredOptions[preferredIndex] = option;
	});

	[...preferredOptions.filter(Boolean), ...rest].forEach((option) => {
		select.appendChild(option);
	});
}

function reorderPhonePrefixes() {
	const preferredCodes = getPreferredCodes();

	document.querySelectorAll(".phone-combined-input").forEach((wrapper) => {
		const group = wrapper.querySelector(".country-flags");
		const flags = wrapper.querySelectorAll(".country-flag");
		if (group && flags.length) {
			const inner = group.querySelector(".country-flags-inner") || group;
			reorderFlagList(inner, preferredCodes);
			markLastPreferred(group);
		} else {
			wrapper.classList.add("phone-combined-input--native-select");
		}
		reorderPhoneCodeSelect(wrapper.querySelector("select.js-phone-code"), preferredCodes);
	});
}
